// extracted by mini-css-extract-plugin
module.exports = {"page":"page__3LkRh","body-wrapper":"body-wrapper__2ZCIf","body":"body__254_V"};